import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'plrEllipsis' })
export class EllipsisPipe implements PipeTransform {
  transform(str: string, strLength: number = 250) {
    const withoutHtml = str.replace(/(<([^>]+)>)/gi, '');

    if (str.length >= strLength) {
      return `${withoutHtml.slice(0, strLength)}...`;
    }

    return withoutHtml;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/ellipsis.pipe.ts